(function () {
  'use strict';

  if (window.__sjwJudgeMePremiumLoaded) return;
  window.__sjwJudgeMePremiumLoaded = true;

  var configNode = document.getElementById('sjw-judge-me-premium-config');
  var copy = {};

  try {
    copy = configNode ? JSON.parse(configNode.textContent || '{}') : {};
  } catch (error) {
    copy = {};
  }

  var trustIcons = {
    honest:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m12 3 2 2.15 2.9-.16.68 2.82L20 9.4l-1.14 2.68.9 2.77-2.57 1.39-.43 2.88-2.91-.42L12 21l-1.85-2.3-2.91.42-.43-2.88-2.57-1.39.9-2.77L4 9.4l2.42-1.59.68-2.82 2.9.16L12 3Z" stroke="currentColor" stroke-width="1.35" stroke-linejoin="round"/><path d="m8.25 12.1 2.25 2.2 5.2-5.15" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    photos:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3.5" y="5.5" width="14.5" height="13" rx="2" stroke="currentColor" stroke-width="1.4"/><circle cx="8" cy="10" r="1.4" stroke="currentColor" stroke-width="1.3"/><path d="m5.5 16 3.25-3.1 2.35 2.1 2.05-1.75L16 16" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M20 3.5v4M18 5.5h4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
    secure:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3.25 19 6v5.15c0 4.45-2.65 7.35-7 9.6-4.35-2.25-7-5.15-7-9.6V6l7-2.75Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="m8.6 12 2.15 2.1 4.65-4.55" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  function makeElement(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (typeof text === 'string') element.textContent = text;
    return element;
  }

  function syncReviewModalState(modal) {
    var isOpen = false;

    if (modal && document.documentElement.contains(modal)) {
      var stateSignature = [
        modal.getAttribute('style') || '',
        modal.className || '',
        modal.getAttribute('aria-hidden') || '',
        modal.hidden ? 'hidden' : 'shown'
      ].join('|');

      if (modal.__sjwReviewStateSignature === stateSignature) {
        isOpen = Boolean(modal.__sjwReviewStateOpen);
        document.body.classList.toggle('sjw-review-modal-open', isOpen);
        return isOpen;
      }

      var styles = window.getComputedStyle(modal);
      isOpen = styles.display !== 'none' && styles.visibility !== 'hidden' && styles.opacity !== '0';

      if (isOpen && modal.getAttribute('aria-hidden') === 'true') {
        modal.removeAttribute('aria-hidden');
      } else if (!isOpen && modal.getAttribute('aria-hidden') !== 'true') {
        modal.setAttribute('aria-hidden', 'true');
      }

      modal.__sjwReviewStateSignature = [
        modal.getAttribute('style') || '',
        modal.className || '',
        modal.getAttribute('aria-hidden') || '',
        modal.hidden ? 'hidden' : 'shown'
      ].join('|');
      modal.__sjwReviewStateOpen = isOpen;
    }

    document.body.classList.toggle('sjw-review-modal-open', isOpen);
    return isOpen;
  }

  function addTrustList(stack) {
    if (!stack || stack.querySelector('.sjw-jdgm__trust')) return;

    var items = [
      { label: copy.trustHonest, icon: trustIcons.honest },
      { label: copy.trustPhotos, icon: trustIcons.photos },
      { label: copy.trustSecure, icon: trustIcons.secure }
    ].filter(function (item) {
      return Boolean(item.label);
    });
    if (!items.length) return;

    var list = makeElement('ul', 'sjw-jdgm__trust');
    list.setAttribute('role', 'list');

    items.forEach(function (trustItem) {
      var item = document.createElement('li');
      item.innerHTML = trustItem.icon;
      item.appendChild(document.createTextNode(trustItem.label));
      list.appendChild(item);
    });

    stack.appendChild(list);
  }

  function addProductImage(root, widget, stack) {
    if (!root || !widget || !stack || stack.querySelector('.sjw-jdgm__product')) return;

    var imageUrl = widget.getAttribute('data-image-url');
    if (!imageUrl) return;

    var figure = makeElement('figure', 'sjw-jdgm__product');
    var image = document.createElement('img');
    image.src = imageUrl;
    image.alt = root.getAttribute('data-product-title') || '';
    image.width = 104;
    image.height = 104;
    image.loading = 'lazy';
    image.decoding = 'async';
    figure.appendChild(image);
    stack.insertBefore(figure, stack.firstChild);
  }

  function addEyebrow(title) {
    if (!title || !copy.eyebrow) return;
    var stack = title.parentElement;
    if (!stack || stack.querySelector('.sjw-jdgm__eyebrow')) return;
    stack.insertBefore(makeElement('p', 'sjw-jdgm__eyebrow', copy.eyebrow), title);
  }

  function revealSection(section) {
    if (!section || section.dataset.sjwJudgeMeObserved === 'true') return;
    section.dataset.sjwJudgeMeObserved = 'true';
    section.classList.add('sjw-judgeme-section--motion');

    if (!('IntersectionObserver' in window)) {
      section.classList.add('sjw-judgeme-section--visible');
      return;
    }

    var revealObserver = new IntersectionObserver(
      function (entries) {
        if (!entries[0] || !entries[0].isIntersecting) return;
        section.classList.add('sjw-judgeme-section--visible');
        revealObserver.disconnect();
      },
      { rootMargin: '100px 0px', threshold: 0.08 }
    );

    revealObserver.observe(section);
  }

  function decorateWidget() {
    var root = document.getElementById('judgeme_product_reviews');
    if (!root || !root.querySelector('.jm-review-widget')) return false;

    var widget = root.querySelector('.jm-review-widget');
    var emptyState = root.querySelector('.jm-no-reviews-state');
    var isEmpty = Boolean(emptyState);
    var section = root.closest('.shopify-section');

    root.classList.add('sjw-jdgm');
    root.classList.toggle('sjw-jdgm--empty', isEmpty);

    if (section) {
      section.classList.add('sjw-judgeme-section');
      revealSection(section);
    }

    var title = root.querySelector('.jm-review-widget-minimal-header__title');
    if (title) {
      addEyebrow(title);
      title.textContent = isEmpty
        ? copy.emptySectionTitle || title.textContent
        : copy.reviewsSectionTitle || title.textContent;
      title.setAttribute('role', 'heading');
      title.setAttribute('aria-level', '2');
    }

    /* Signora (2 Nov 2026): this widget counts reviews of this design only; say so, next to the site-wide number
       shown in the product header and on the reviews page, so the two numbers don't look contradictory. */
    if (!isEmpty && copy.allCount && !root.querySelector('.sjw-jdgm__scope')) {
      var head = title && title.parentNode;
      var allRating = Number(copy.allRating);
      var scope = makeElement('p', 'sjw-jdgm__scope', 'Reviews of this design. All Signora reviews: ' +
        (isFinite(allRating) && allRating ? allRating.toFixed(2) + ' from ' : '') + copy.allCount + '.');
      scope.style.cssText = 'margin:8px 0 0;font-size:13.5px;line-height:1.45;opacity:.8';
      if (head) head.insertAdjacentElement('afterend', scope);
    }

    if (isEmpty) {
      var emptyStack = emptyState.querySelector('.jm-stack');
      var emptyTitle = emptyState.querySelector('.jm-no-reviews-state__text');
      var actionButton = emptyState.querySelector('[data-testid="write-review-button"]');

      addProductImage(root, widget, emptyStack);

      if (emptyTitle) {
        emptyTitle.textContent = copy.emptyTitle || emptyTitle.textContent;
        emptyTitle.setAttribute('role', 'heading');
        emptyTitle.setAttribute('aria-level', '3');

        if (copy.emptyCopy && emptyStack && !emptyStack.querySelector('.sjw-jdgm__intro')) {
          emptyTitle.insertAdjacentElement('afterend', makeElement('p', 'sjw-jdgm__intro', copy.emptyCopy));
        }
      }

      if (actionButton && copy.cta) {
        actionButton.textContent = copy.cta;
        actionButton.setAttribute('aria-label', copy.cta);
      }

      addTrustList(emptyStack);
    }

    return true;
  }

  function addModalProgress(page, total) {
    if (!page || page.querySelector('.sjw-jdgm-modal__progress')) return;

    var current = Number(page.getAttribute('data-page')) || 1;
    var header = page.querySelector('.jdgm-write-review-modal__page-header');
    if (!header) return;

    var progress = makeElement('div', 'sjw-jdgm-modal__progress');
    var currentLabel = makeElement('span', 'sjw-jdgm-modal__progress-current');
    var track = makeElement('span', 'sjw-jdgm-modal__progress-track');
    var fill = makeElement('span', 'sjw-jdgm-modal__progress-fill');
    var totalLabel = makeElement('span', 'sjw-jdgm-modal__progress-total');
    var stepLabel = copy.stepLabel || 'Step';
    var stepOf = copy.stepOf || 'of';

    currentLabel.textContent = String(current).padStart(2, '0');
    totalLabel.textContent = String(total).padStart(2, '0');
    track.appendChild(fill);
    progress.appendChild(currentLabel);
    progress.appendChild(track);
    progress.appendChild(totalLabel);
    progress.style.setProperty('--sjw-review-progress', String((current / total) * 100) + '%');
    progress.setAttribute('role', 'progressbar');
    progress.setAttribute('aria-label', [stepLabel, current, stepOf, total].join(' '));
    progress.setAttribute('aria-valuemin', '1');
    progress.setAttribute('aria-valuemax', String(total));
    progress.setAttribute('aria-valuenow', String(current));
    header.insertBefore(progress, header.firstChild);
  }

  function decorateMediaPage(modal) {
    var mediaPage = modal.querySelector('.jdgm-write-review-modal__page--share-media');
    if (!mediaPage) return;

    var title = mediaPage.querySelector('.jdgm-write-review-modal__title');
    var intro = mediaPage.querySelector('.jdgm-write-review-modal__intro');
    var header = mediaPage.querySelector('.jdgm-write-review-modal__page-header');
    var upload = mediaPage.querySelector('.jdgm-write-review-modal__media-upload');
    var prompt = mediaPage.querySelector('.jdgm-write-review-modal__media-upload-prompt');
    var fileInput = mediaPage.querySelector('input[type="file"]');

    if (title && copy.mediaTitle) title.textContent = copy.mediaTitle;
    if (intro && copy.mediaIntro) intro.textContent = copy.mediaIntro;

    if (header && copy.mediaOptional && !header.querySelector('.sjw-jdgm-modal__optional')) {
      header.appendChild(makeElement('span', 'sjw-jdgm-modal__optional', copy.mediaOptional));
    }

    if (prompt && !prompt.classList.contains('sjw-jdgm-modal__upload-prompt')) {
      prompt.textContent = '';
      prompt.classList.add('sjw-jdgm-modal__upload-prompt');
      prompt.appendChild(makeElement('b', '', copy.mediaUpload || 'Choose photos or video'));
      prompt.appendChild(document.createTextNode(' ' + (copy.mediaDrag || 'or drag and drop')));
    }

    if (upload && copy.mediaFormats && !upload.querySelector('.sjw-jdgm-modal__formats')) {
      upload.appendChild(makeElement('p', 'sjw-jdgm-modal__formats', copy.mediaFormats));
    }

    if (fileInput) {
      fileInput.id = fileInput.id || 'sjw-jdgm-media-input';
      fileInput.setAttribute('aria-label', copy.mediaInputLabel || fileInput.getAttribute('aria-label') || 'Upload photos or video');
    }
  }

  function decorateModalPages(modal) {
    var pages = Array.prototype.slice
      .call(modal.querySelectorAll('.jdgm-write-review-modal__page'))
      .filter(function (page) {
        return page.hasAttribute('data-page') && !page.classList.contains('jdgm-write-review-modal__page--thank-you');
      });
    var total = pages.length || 4;

    pages.forEach(function (page) {
      addModalProgress(page, total);
    });

    modal.querySelectorAll('.jdgm-star[data-alt]').forEach(function (star) {
      if (star.title) star.setAttribute('aria-label', star.title);
    });

    decorateMediaPage(modal);
  }

  function syncModalViewport(modal) {
    var content = modal.querySelector('.jdgm-write-review-modal__content');
    var currentPage = modal.querySelector('.jdgm-write-review-modal__page.current-page');
    var currentPageNumber = currentPage ? currentPage.getAttribute('data-page') : '';

    if (!content || !currentPageNumber || modal.dataset.sjwCurrentReviewPage === currentPageNumber) return;

    /*
     * Judge.me's horizontal slider can make the scrollable modal content follow
     * the focused field, shifting later steps off centre. Keep the viewport on
     * the slider origin and begin each newly displayed step at its top edge.
     */
    modal.dataset.sjwCurrentReviewPage = currentPageNumber;
    content.scrollLeft = 0;
    content.scrollTop = 0;

    window.requestAnimationFrame(function () {
      content.scrollLeft = 0;
      content.scrollTop = 0;
    });
  }

  function decorateModal() {
    var modal = document.querySelector('.jdgm-write-review-modal');
    if (!modal) {
      syncReviewModalState(null);
      return false;
    }

    modal.classList.add('sjw-jdgm-modal');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    syncReviewModalState(modal);

    var closeButton = modal.querySelector('.jdgm-write-review-modal__close-btn');
    if (closeButton) {
      closeButton.classList.add('sjw-jdgm-modal__native-close');
      closeButton.setAttribute('aria-hidden', 'true');
      closeButton.setAttribute('tabindex', '-1');
    }

    var container = modal.querySelector('.jdgm-write-review-modal__container');
    var premiumClose = container ? container.querySelector('.sjw-jdgm-modal__close') : null;

    if (container && !premiumClose) {
      premiumClose = makeElement('button', 'sjw-jdgm-modal__close', '×');
      premiumClose.type = 'button';
      premiumClose.addEventListener('click', function () {
        var nativeClose = modal.querySelector('.jdgm-write-review-modal__close-btn');
        if (nativeClose) nativeClose.click();

        window.setTimeout(function () {
          if (!syncReviewModalState(modal)) return;
          var overlay = modal.querySelector('.jdgm-write-review-modal__overlay');
          if (overlay) overlay.click();
          syncReviewModalState(modal);
        }, 80);

        window.setTimeout(function () {
          if (!syncReviewModalState(modal)) return;
          modal.style.display = 'none';
          modal.setAttribute('aria-hidden', 'true');
          syncReviewModalState(modal);
          var reviewTrigger = document.querySelector('[data-testid="write-review-button"]');
          if (reviewTrigger) reviewTrigger.focus({ preventScroll: true });
        }, 180);
      });
      container.appendChild(premiumClose);
    }

    if (premiumClose) premiumClose.setAttribute('aria-label', copy.close || 'Close review form');

    var introPage = modal.querySelector('.jdgm-write-review-modal__section--review-form-intro');
    if (introPage) {
      var header = introPage.querySelector('.jdgm-write-review-modal__page-header');
      var title = introPage.querySelector('.jdgm-write-review-modal__title');
      var intro = introPage.querySelector('.jdgm-write-review-modal__intro');

      if (header && copy.modalEyebrow && !header.querySelector('.sjw-jdgm-modal__eyebrow')) {
        header.insertBefore(makeElement('p', 'sjw-jdgm-modal__eyebrow', copy.modalEyebrow), header.firstChild);
      }

      if (title) {
        title.textContent = copy.modalTitle || title.textContent;
        title.id = title.id || 'sjw-jdgm-modal-title';
        modal.setAttribute('aria-labelledby', title.id);
      }

      if (intro && copy.modalIntro) intro.textContent = copy.modalIntro;
    }

    decorateModalPages(modal);
    syncModalViewport(modal);

    if (!modal.__sjwJudgeMePremiumObserver) {
      var modalObserver = new MutationObserver(function (records) {
        var modalStateChanged = records.some(function (record) {
          return record.type === 'attributes' && record.target === modal;
        });
        if (modalStateChanged) syncReviewModalState(modal);

        var missingClose = !modal.querySelector('.sjw-jdgm-modal__close');
        var missingProgress = Array.prototype.some.call(
          modal.querySelectorAll('.jdgm-write-review-modal__page[data-page]:not(.jdgm-write-review-modal__page--thank-you)'),
          function (page) {
            return !page.querySelector('.sjw-jdgm-modal__progress');
          }
        );

        if (!missingClose && !missingProgress) return;
        window.requestAnimationFrame(decorateModal);
      });

      modalObserver.observe(modal, {
        attributes: true,
        attributeFilter: ['style', 'class', 'aria-hidden'],
        childList: true,
        subtree: true
      });
      modal.__sjwJudgeMePremiumObserver = modalObserver;
    }

    return true;
  }

  function hideEmptyAppSections() {
    document.querySelectorAll('.template-product .apps-section').forEach(function (appsSection) {
      if (appsSection.querySelector('*') || appsSection.textContent.trim()) return;
      var section = appsSection.closest('.shopify-section');
      if (section) section.classList.add('sjw-empty-app-section');
    });
  }

  var scheduled = false;
  var observer = null;
  function enhance() {
    scheduled = false;
    var widgetReady = decorateWidget();
    var modalReady = decorateModal();
    hideEmptyAppSections();
    if (widgetReady && modalReady && observer) observer.disconnect();
    return widgetReady && modalReady;
  }

  function scheduleEnhance() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(enhance);
  }

  scheduleEnhance();

  observer = new MutationObserver(scheduleEnhance);
  observer.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('load', scheduleEnhance, { once: true });

  /*
   * Judge.me can recreate the modal only when the CTA is clicked, long after its
   * initial widget render. Re-decorate at a few short intervals so Vue's final
   * hydrated modal receives the class and localized intro without keeping a
   * document-wide MutationObserver alive for the full browsing session.
   */
  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target && event.target.closest
        ? event.target.closest(
            '[data-testid="write-review-button"], .jdgm-write-review-modal__nav-btn, .jdgm-write-review-modal .jdgm-star'
          )
        : null;
      if (!trigger) return;

      [0, 80, 240, 600, 1200].forEach(function (delay) {
        window.setTimeout(decorateModal, delay);
      });
    },
    true
  );

  window.setTimeout(function () {
    enhance();
    observer.disconnect();
  }, 12000);
})();
